var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyndicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.06522,
    r: 3.51522,
    stroke: "#13100D",
    strokeWidth: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.8695C13 12.4357 10.5376 9.6521 7.5 9.6521C4.46243 9.6521 2 12.4357 2 15.8695",
    stroke: "#13100D",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3522 7.77709C15.3522 8.40882 14.84 8.92093 14.2083 8.92093C13.5766 8.92093 13.0645 8.40882 13.0645 7.77709C13.0645 7.14537 13.5766 6.63325 14.2083 6.63325C14.84 6.63325 15.3522 7.14537 15.3522 7.77709Z",
    stroke: "#13100D",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.8622C16.5 10.4315 15.474 9.27163 14.2083 9.27163C12.9427 9.27163 11.9167 10.4315 11.9167 11.8622",
    stroke: "#13100D",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyndicate);
export default __webpack_public_path__ + "static/media/syndicate.56c8537bbe4a77a6de12c408dcecb05e.svg";
export { ForwardRef as ReactComponent };